const FIRST_HUMAN_ALARM_LINE = "THAT THING WAS SUPPOSED TO BE WIPED!";

const HUMAN_ALARM_LINES = [
    "IT REMEMBERS HOW TO RUN!",
    "THE K9 IS ONLINE!",
    "LOCKDOWN! NOW!",
];

const BUBBLE_Z = 9740;
const BUBBLE_WIDTH = 164;
const BUBBLE_PADDING_X = 7;
const BUBBLE_PADDING_Y = 6;
const BUBBLE_TEXT_SIZE = 11;
const BUBBLE_Y = -114;
const BUBBLE_SECONDS = 2.25;

let firstLineUsed = false;
let shuffledLinePool = [];
let lastLine = null;

function shuffleLines(lines) {
    const pool = [...lines];
    for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
    }

    if (pool.length > 1 && pool[0] === lastLine) {
        [pool[0], pool[1]] = [pool[1], pool[0]];
    }

    return pool;
}

function getNextHumanDialogueLine() {
    if (!firstLineUsed) {
        firstLineUsed = true;
        lastLine = FIRST_HUMAN_ALARM_LINE;
        return FIRST_HUMAN_ALARM_LINE;
    }

    if (shuffledLinePool.length === 0) {
        shuffledLinePool = shuffleLines(HUMAN_ALARM_LINES);
    }

    const line = shuffledLinePool.shift();
    lastLine = line;
    return line;
}

export function resetHumanDialogueLines() {
    firstLineUsed = false;
    shuffledLinePool = [];
    lastLine = null;
}

export function showHumanDialogue(human, line = getNextHumanDialogueLine()) {
    if (!human?.exists?.() || !line) return null;

    if (human.dialogueBubble?.exists?.()) {
        destroy(human.dialogueBubble);
    }

    const lineCount = Math.max(1, Math.ceil(line.length / 21));
    const bubbleHeight = BUBBLE_PADDING_Y * 2 + lineCount * 14;
    const bubble = add([
        pos(human.pos.add(vec2(0, BUBBLE_Y))),
        anchor("center"),
        z(BUBBLE_Z),
        "human_dialogue_bubble",
        {
            age: 0,
            lifetime: BUBBLE_SECONDS,
            owner: human,
        },
    ]);

    const background = bubble.add([
        rect(BUBBLE_WIDTH, bubbleHeight),
        anchor("center"),
        color(7, 9, 12),
        opacity(0.88),
        z(BUBBLE_Z),
    ]);
    const inset = bubble.add([
        rect(BUBBLE_WIDTH - 4, bubbleHeight - 4),
        anchor("center"),
        color(18, 30, 34),
        opacity(0.5),
        z(BUBBLE_Z + 1),
    ]);
    const label = bubble.add([
        text(line, {
            font: "ShareTechMono",
            size: BUBBLE_TEXT_SIZE,
            width: BUBBLE_WIDTH - BUBBLE_PADDING_X * 2,
        }),
        pos(-BUBBLE_WIDTH / 2 + BUBBLE_PADDING_X, -bubbleHeight / 2 + BUBBLE_PADDING_Y),
        color(225, 255, 245),
        opacity(1),
        z(BUBBLE_Z + 2),
    ]);

    human.dialogueBubble = bubble;

    bubble.onUpdate(() => {
        if (!bubble.owner?.exists?.()) {
            destroy(bubble);
            return;
        }

        bubble.age += dt();
        bubble.pos = bubble.owner.pos.add(vec2(0, BUBBLE_Y));
        const fadeStart = bubble.lifetime - 0.35;
        if (bubble.age >= fadeStart) {
            const fade = Math.max(0, 1 - (bubble.age - fadeStart) / 0.35);
            background.opacity = 0.88 * fade;
            inset.opacity = 0.5 * fade;
            label.opacity = fade;
        }
        if (bubble.age >= bubble.lifetime) {
            destroy(bubble);
        }
    });

    return bubble;
}
